export default [ { path: '/faqs', text: 'FAQS' }, { path: '/privacypolicy', text: 'PRIVACY POLICY' } ];
